var React = require('react');

function ChevronThinUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-thin-up"),React.createElement("path",{"d":"M2.582 13.891c-0.272 0.268-0.709 0.268-0.979 0s-0.271-0.701 0-0.969l7.908-7.83c0.27-0.268 0.707-0.268 0.979 0l7.908 7.83c0.27 0.268 0.27 0.701 0 0.969s-0.709 0.268-0.978 0l-7.42-7.141-7.418 7.141z","key":1})]);
}

ChevronThinUp.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ChevronThinUp;

ChevronThinUp.default = ChevronThinUp;
